import type { MaybeRefOrGetter, Ref } from "vue";

interface PageTitleSources {
  base: MaybeRefOrGetter<string>;
  page?: Ref<number>;
  search?: Ref<string>;
  filterCount?: Ref<number>;
}

function buildLabel(base: string, modifiers: string[], head: string) {
  return modifiers.length ? `${head} (${modifiers.join(", ")})` : head;
}

export function usePageTitle(sources: PageTitleSources) {
  const { t } = useI18n();

  const title = computed(() => {
    const base = toValue(sources.base);
    const search = sources.search?.value?.trim();
    const page = sources.page?.value ?? 1;
    const filterCount = sources.filterCount?.value ?? 0;

    const modifiers: string[] = [];
    if (page > 1) modifiers.push(t("ui.page", { page }));
    if (filterCount > 0) modifiers.push(t("ui.activeFilters", filterCount));

    const head = search ? t("ui.titleWithSearch", { term: search, base }) : base;
    return buildLabel(base, modifiers, head);
  });

  const breadcrumbLabel = computed(() => {
    const base = toValue(sources.base);
    const page = sources.page?.value ?? 1;
    const modifiers = page > 1 ? [t("ui.page", { page })] : [];
    return buildLabel(base, modifiers, base);
  });

  return { title, breadcrumbLabel };
}
